import React from 'react'
import { StaticQuery, graphql } from 'gatsby'

import {
  TwitterIcon,
  FacebookIcon,
  InstagramIcon,
  // KopaIconFooter,
  // KopaIcon,
  LinkedInIcon,
  // TalkPsoriasisIcon,
  YouTubeIcon,
} from './Icons'
import * as Styled from './styles/Utility.styles'

const SOCIAL_LINK_QUERY = graphql`
  {
    prismicGeneralSiteSettings {
      data {
        npf_social_link_facebook {
          url
          target
        }
        npf_social_link_instagram {
          url
          target
        }
        npf_social_link_linkedin {
          url
          target
        }
        npf_social_link_twitter {
          url
          target
        }
        npf_social_link_youtube {
          url
          target
        }
        npf_social_link_talk_psoriasis_footer {
          url
          target
        }
        npf_social_link_talk_psoriasis_nav_menu {
          url
          target
        }
      }
    }
  }
`

const SocialIconLink = ({ children, url, target = '_blank' }) => (
  <a href={url} target={target} rel="noopener noreferrer">
    {children}
  </a>
)

const SocialIconRow = ({ marginTop = null, isFooter = false }) => (
  <StaticQuery
    query={`${SOCIAL_LINK_QUERY}`}
    render={data => {
      const node = data.prismicGeneralSiteSettings.data
      return (
        <Styled.SocialIconRow marginTop={marginTop}>
          <SocialIconLink
            url={node.npf_social_link_facebook.url}
            target={node.npf_social_link_facebook.target}
          >
            <FacebookIcon />
          </SocialIconLink>

          <SocialIconLink
            url={node.npf_social_link_instagram.url}
            target={node.npf_social_link_instagram.target}
          >
            <InstagramIcon />
          </SocialIconLink>

          <SocialIconLink
            url={node.npf_social_link_twitter.url}
            target={node.npf_social_link_twitter.target}
          >
            <TwitterIcon />
          </SocialIconLink>

          <SocialIconLink
            url={node.npf_social_link_linkedin.url}
            target={node.npf_social_link_linkedin.target}
          >
            <LinkedInIcon />
          </SocialIconLink>

          <SocialIconLink
            url={node.npf_social_link_youtube.url}
            target={node.npf_social_link_youtube.target}
          >
            <YouTubeIcon />
          </SocialIconLink>
        </Styled.SocialIconRow>
      )
    }}
  />
)

export default SocialIconRow
